// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
//
import TourGuideItemEditForm from '../tour-guide-item-edit-form';

// ----------------------------------------------------------------------

export default function TourGuideItemView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Configure Items For Tour Guide Schema"
        links={[
          {
            name: 'Dashboard',
            href: paths.dashboard.root,
          },
          {
            name: 'Tour Guides',
            href: paths.dashboard.tourGuide.root,
          },
          { name: 'Configure Items For Tour Guide' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <TourGuideItemEditForm />
    </Container>
  );
}
